import { gql } from "__generated__/gql";

export const getAgreements_query = gql(`#graphql
	query getAgreements($search: AgreementSearch!) {
		agreements(search: $search) {
			id
			type
			priority
			description
			createdOn
			manualActionRequired
			invoiceTo {
				id
				name
			}
			costType {
				id
				title_de
				title_en
				title_nl
			}
			invoiceGroupType {
				id
				name
				charterTypes
			}
			summary
			conditionsSummary
			isDefault
			... on BlockFreightAgreement {
				days
			}
			... on RentAgreement {
				shipAvailability {
					...availabilityFragment
				}
				workdays
				declarationMonthTerm
			}
			... on ShipAgreement {
				ships {
					id
					name
					owner {
						id
						name
					}
				}
			}
			... on WaterwayAgreement {
				location {
					id
					description
					displayCode
					locationGroups {
						id
						description
						displayCode
					}
				}
			}
			calculationMethod {
				id
				type
				price
				minimumPrice
				minimumQuantityPayable
				preAgreed
				payableOver
				description
				customUnit
				summary
				... on CargoQuantityCalculationMethod {
					cargoQuantityUnit
					weightRanges {
						from
						to
						price
					}
				}
				... on PercentageOnAgreementsCalculationMethod {
					percentage
					applicableAgreementTypes
					applicableAgreements {
						id
						type
						description
						summary
						calculationMethod {
							id
							type
							description
							price
							summary
						}
					}
				}
				... on TimeUnitCalculationMethod {
					timeUnit
					minimumTimeUnitsPayable
				}
				... on QuantityUnitCalculationMethod {
					quantityUnit
				}
				... on DemurrageCalculationMethod {
					pricePerCargoQuantityUnit
					demurrageTerms
					demurragePayableOver
					timeUnit
					cargoQuantityUnit
					demurrageCountingType
					shortNotice
					startCountingTime
					workingHoursSinceNomination
					workingDaysSinceNomination
					laytimeAllowed
				}
				... on DemurrageCalculationCalculationMethod {
					laytimeRoundingRule
					laytimeRoundingUnit
					laytimeRoundingScope
					laytimePeriodRegime
					demurrageCalculationUnit
					laytimeAllowed
					defaultCargoActionTypes
				}
				... on GasoilConsumptionCalculationMethod {
					priceSource
					referenceRateDateType
				}
				... on ReferenceRateCalculationMethod {
					referenceRateUnit
					referenceRateBase
					referenceRateDateType
					route
					loadLocation {
						id
						description
						displayCode
						locationGroups {
							id
							description
							displayCode
						}
					}
					dischargeLocation {
						id
						description
						displayCode
						locationGroups {
							id
							description
							displayCode
						}
					}
					adjustmentType
					adjustmentAmount
					pjkTariff
				}
				... on StaffelCalculationMethod {
					staffelUnit
					staffel {
						... staffelFragment
					}
					staffelItem {
						... staffelItemFragment
					}
				}
				... on TieredCalculationMethod {
					tierUnit
					cargoQuantityUnit
					referenceRateDateType
					cdniCostIncluded
					waterLevelLocation
					tiers {
						id
						minimum
						maximum
						priceUnit
						price
						pricePerMtAdditionalToLumpsum
					}
					applicableAgreementTypes
					applicableAgreements {
						id
						type
						description
						summary
					}
				}
			}
			conditions {
				id
				type
				... on ContainerFullCondition {
					empty
				}
				... on LocationCondition {
					location {
						id
						description
					}
					locationActionType
				}
				... on ProductCondition {
					product {
						id
						name
						code
					}
				}
				... on RouteCondition {
					fromLocation {
						id
						description
					}
					toLocation {
						id
						description
					}
				}
				... on ShipCondition {
					ship {
						id
						name
					}
				}
				... on WaterLevelCondition {
					waterLevelLocation
					waterLevelMin
					waterLevelMax
				}
				... on ReeferCheckTypeCondition {
					reeferCheckType
				}
			}
		}
	}
`);

export const getCompatibleAgreementsByCharterType_query = gql(`#graphql
	query getCompatibleAgreementsByCharterType($charterType: CharterType, $charterSubtype: CharterSubtype, $isParentContract: Boolean, $isChildContract: Boolean) {
		compatibleAgreementsByCharterType(charterType: $charterType, charterSubtype: $charterSubtype, isParentContract: $isParentContract, isChildContract: $isChildContract)
	}
`);

export const getCompatibleCalculationMethodsByAgreementType_query = gql(`#graphql
	query getCompatibleCalculationMethodsByAgreementType($agreementType: AgreementTypeEnum) {
		compatibleCalculationMethodsByAgreementType(agreementType: $agreementType)
	}
`);

export const getCompatibleConditionsByAgreementType_query = gql(`#graphql
	query getCompatibleConditionsByAgreementType($agreementType: AgreementTypeEnum) {
		compatibleConditionsByAgreementType(agreementType: $agreementType)
	}
`);

export const getAgreementListMasterData_query = gql(`#graphql
	query getAgreementListMasterData {
		costTypes {
			id
			title_en
			title_nl
			title_de
		}
		agreementTypes {
			id
			type
			costType {
				id
				title_en
				title_nl
				title_de
			}
			invoiceGroupTypeSales {
				id
				name
				charterTypes
			}
			invoiceGroupTypePurchase {
				id
				name
				charterTypes
			}
			agreementTypeOrder
		}
		products {
			id
			name
		}
	}
`);

export const getDefaultCargoActionTypes_query = gql(`#graphql
	query getDefaultCargoActionTypes($agreementId: Long!) {
		defaultCargoActionTypesForDemurrage(agreementId: $agreementId)
	}
`);

export const updateDefaultCargoActionTypes_mutation = gql(`#graphql
	mutation updateDefaultCargoActionTypes($charterId: Long!, $agreementId: Long!) {
		updateDefaultCargoActionTypes(charterId: $charterId, agreementId: $agreementId)
	}
`);
